angular.module('LeasePilot').directive('deleteBuildingConfirmationModal', [
  '$rootScope',
  '$mdDialog',
  '$http',
  'BuildingService',
  function(
    $rootScope,
    $mdDialog,
    $http,
    BuildingService,
  ) {
    return {
      restrict: 'E',
      templateUrl: 'delete_building_confirmation_modal.html',
      scope: {
        id: "@",
        name: "@",
        building: "=?",
      },
      link: function($scope) {
        if ($scope.building) {
          $scope.id = $scope.building.id;
          $scope.name = $scope.building.displayName;
        }

        $scope.building = {
          id: $scope.id,
          name: $scope.name
        };
        
        $scope.isProcessing = false;
        $scope.confirm = "";

        $scope.deleteBuilding = function() {
          if ($scope.confirm !== "DELETE BUILDING") {
            return;
          }

          $scope.isProcessing = true;
          window.track.event(new DeleteBuildingEvent({
            id: $scope.id,
            name: $scope.name,
          }));

          new BuildingService({ id: $scope.id }).delete().then(
            function() {
              $mdDialog.cancel();
              window.location.reload();
            },
            function(error) {
              console.error(error);
              $scope.error = error.message;
              $scope.isProcessing = false;
            }
          );
        };

        $scope.cancel = function() {
          window.track.event(new CancelDeleteBuildingEvent({
            id: $scope.id,
          }));
          $mdDialog.cancel();
        };
      },
    };
  },
]);
